export const ONBOARDING_SCOPE_QUERY_KEY = "onboarding-scope";
export const ONBOARDING_SEGMENT_QUERY_KEY = "onboarding-segment";
export const ONBOARDING_PERIOD_QUERY_KEY = "onboarding-period";

export const ONBOARDING_FILTER_QUERY_KEYS = [ONBOARDING_SCOPE_QUERY_KEY, ONBOARDING_SEGMENT_QUERY_KEY, ONBOARDING_PERIOD_QUERY_KEY] as const;
